import { useLocation, useParams } from 'react-router-dom';

import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { SystemGeneratedDocumentsTypesEnum } from '../../utilities/Constants';
import { Trends } from '../report/Trends';
import { useAuthContext } from '../../contexts/AuthContext';
import { useGetStaticDataDate } from '../../shared/react-query-hooks/useGetStaticDataDate';
import { useZoneContext } from '../../contexts/useZoneContext';

function TrendsWrapper() {
    const { key } = useParams();
    const { user } = useAuthContext();
    const location = useLocation();
    const zoneContext = useZoneContext();

    const reportDate = useGetStaticDataDate(SystemGeneratedDocumentsTypesEnum.Trends.Value);

    return (
        <>
            <DocumentTitle title="Trends" />
            <Trends
                key={key || ''}
                user={user}
                refreshIdentifier={location.key}
                reportDate={reportDate.data}
                zoneContext={zoneContext}
            />
        </>
    );
}

export default TrendsWrapper;
